import { ModalContent, ModalCloseButton, ModalBody } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ModalHeaderWithBackButton } from '$/components/common/Modals/ModalHeaderWithBackButton';
import { SapCxConsentForm } from '$/components/core/Authentication/components/SapCxConsentForm';

export const SapCxConsentModalContent = () => {
  const { t } = useTranslation();

  return (
    <ModalContent maxW='500px' bg='background' borderRadius='12px'>
      <ModalHeaderWithBackButton
        headerText={t('dashboard.authentication.sapCxConsent.modalHeader')}
        mr='8'
        lineHeight='1.1'
      />
      <ModalCloseButton top='0' right='0' mt='8' mr='8' />
      <ModalBody px='10' pb='10'>
        <SapCxConsentForm />
      </ModalBody>
    </ModalContent>
  );
};
